import { Tag } from 'antd';
import { cn } from 'technical/tailwind/cn';
import { useTranslation } from 'translations/hooks';

export const RingCompleteStatusTag = () => {
  const { t } = useTranslation();

  return (
    <Tag
      className={cn(
        'rounded-[10px]',
        'border-green-200 bg-green-100 text-green-700',
      )}
    >
      <span className="mr-1 leading-none">&#x25CF; </span>
      {t('tunnel.complete.status', { context: 'COMPLETE' })}
    </Tag>
  );
};
